import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import "react-datetime/css/react-datetime.css";
import {
  Form,
  FormStyle,
  Formik,
  FormikControl,
  InputError,
} from "@/imports-files/common/common";
import {
  Button,
  ComponentStyle,
} from "@/imports-files/components/confirmation-modal";
import {
  Yup,
  cancelInterviewByCandidate,
  cancelInterviewByClient,
  TRANSLATION,
} from "@/imports-files/pages/interviews/cronofy";
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
export function CancelInterview({
  setBtnPopup,
  token,
  router,
  cancelledBy,
  setInitialData,
  setFlagForRender,
}) {
  function showReasonSection() {
    document.querySelector(".confirmationSection").classList.add("dnone");
    document.querySelector(".reasonSection").classList.remove("dnone");
  }

  const initialValues = {
    reason: "",
  };

  const validationSchema = Yup.object({
    reason: Yup.string().required(TRANSLATION("common:errors:required")),
  });

  const confirmHint =
    cancelledBy == "client"
      ? "This interview is already scheduled. Are you sure you still want to cancel it?"
      : "Are you sure you want to cancel your scheduled interview?";

  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal}`}>
        <div className={`${FormModalStyle.Modal__Container}`}>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => setBtnPopup(false)}
          >
            <Close/>
            CLOSE
          </div>
          <div className={`${FormModalStyle.Modal__Container__ContentSection}`}>
            <h1
              className={` ${FormModalStyle.Modal__Container__ContentSection__Heading}`}
            >
              Cancel Interview
            </h1>
            <h3
              className={`${FormModalStyle.Modal__Container__ContentSection__Description}`}
            >
              {confirmHint}
            </h3>

            <div className={`${ComponentStyle.CancelInterview__Content}`}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  if (cancelledBy == "client")
                    await cancelInterviewByClient(
                      values,
                      token,
                      setBtnPopup,
                      router,
                      setInitialData,
                      setFlagForRender
                    );
                  else
                    await cancelInterviewByCandidate(
                      values,
                      token,
                      router,
                      setBtnPopup,
                      setInitialData
                    );
                }}
              >
                {(formik) => (
                  <Form>
                    <div
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                    >
                      <label
                        className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                      >
                        Reason to Cancel Interview *
                      </label>
                      <FormikControl
                        control="customtextarea"
                        type="text"
                        formik={formik}
                        className={`${PageStyle.Form__Textarea} ${PageStyle.Form__TextareaPlaceholder}`}
                        placeholder="Write here..."
                        name={"reason"}
                        style={InputError(formik, "reason")}
                      />
                    </div>

                    <div
                      className={`${FormModalStyle.Modal__Container__ButtonSection}`}
                    >
                      <Button
                        buttonstyle={ComponentStyle.secondarybtnborder}
                        type="button"
                        onClick={() => setBtnPopup(false)}
                      >
                        No, I've changed my mind
                      </Button>
                      <Button buttonstyle={PageStyle.primarybtn} type="submit">
                        Cancel Interview
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
